<nb-card>
  <nb-card-header>
    {{ "site_control_reports.add_report_dialog_title" | translate }}
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <nb-radio-group [(ngModel)]="selectedMethod">
        <nb-radio value="automatic">
          {{ "site_control_reports.automatic_import" | translate }}
        </nb-radio>
        <nb-radio value="manual">
          {{ "site_control_reports.manual_entry" | translate }}
        </nb-radio>
      </nb-radio-group>
    </div>
  </nb-card-body>
  <nb-card-footer class="text-right">
    <button nbButton status="basic" class="cancel-button" (click)="cancel()">
      {{ "Cancel" | translate }}
    </button>
    <button nbButton status="primary" (click)="confirm()" class="ms-3">
      {{ "OK" | translate }}
    </button>
  </nb-card-footer>
</nb-card>

